module.exports = __webpack_public_path__ + "img/subject.2f7242c7.png";